import { render, staticRenderFns } from "./StDocxTemplater.vue?vue&type=template&id=1f1dd3aa&"
import script from "./StDocxTemplater.vue?vue&type=script&lang=js&"
export * from "./StDocxTemplater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports